import React from 'react'
import { Footer, Navbar } from "../components";
// import breadcrumbBanner from "../assets/img/breadcrumb/01.jpg";

// const breadcrumbbg = {
//   backgroundImage: `url(${breadcumbBanner})`,
// };

const RefundPage = () => {
  return (
    <>
    <style>
        {`
          .refund-list {
            list-style: disc;
            padding-left: 0;
          }
        .terms-content p:not(:last-child) {
            margin-bottom: 26px;
            margin-top: 25px;
        }
        `}
      </style>
      <Navbar />
      <div class="site-breadcrumb">
            <div class="container">
                <h2 class="breadcrumb-title">Padhai Dekho Refund Policy</h2>
                <ul class="breadcrumb-menu">
                    <li><a href="#">Home</a></li>
                    <li class="active">Refund Policy</li>
                </ul>
            </div>
        </div>
        <div class="py-5">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="terms-content">
                            <h3>Refund policy</h3>
                            <p>At <a href="https://padhaidekho.com">Padhaidekho.com</a>, we strive to provide the best educational services and a seamless learning experience. However, we understand that situations may arise where a refund is necessary. Please read our refund policy carefully before making a purchase.</p>
                            <p><strong>1. Course Purchases</strong></p>
                            <ul style={{ paddingLeft: "30px" }}>
                                <li className="refund-list">Trial Period: If a course includes a trial period, you may cancel within the trial period for a full refund.</li>
                                <li className="refund-list">Refund Eligibility: Refunds for purchased courses are only considered if:</li>
                                <li className="refund-list">The course content is not delivered as described.</li>
                                <li className="refund-list">Technical issues prevent access to the course and cannot be resolved within 7 working days.</li>
                                <li className="refund-list">You have not accessed more than 20% of the course content.</li>
                                <li className="refund-list">Non-Refundable Cases:</li>
                                <li className="refund-list">No refunds will be provided for change of mind or accidental purchases.</li>
                                <li className="refund-list">Refunds will not be given if the course has been completed or accessed beyond the stated limit.</li>
                                <li className="refund-list">Discounts, promotional offers, or bundled packages are non-refundable.</li>
                            </ul>
                            <p><strong>2. Institute and Professor Registration</strong></p>
                            <ul style={{ paddingLeft: "30px" }}>
                                <li className="refund-list">Registration Fees: Registration fees for institutes and professors are non-refundable unless:</li>
                                <li className="refund-list">There is a technical issue preventing the completion of registration.</li>
                                <li className="refund-list">The platform fails to provide the agreed services within 7 working days of registration.</li>
                            </ul>
                            <p><strong>3. Processing of Refunds</strong></p>
                            <ul style={{ paddingLeft: "30px" }}>
                                <li className="refund-list">Approved refunds will be credited within 7–10 business days to the original payment method.</li>
                                <li className="refund-list">Any processing fees charged by the payment gateway are non-refundable.</li>
                                <li className="refund-list">The platform fails to provide the agreed services within 7 working days of registration.</li>
                            </ul>
                            <p><strong>4. Requesting a Refund</strong></p>
                            <p>To request a refund, please contact our support team at support@padhaidekho.com with the following details:</p>
                            <ul style={{ paddingLeft: "30px" }}>
                                <li className="refund-list">Order ID or registration reference number.</li>
                                <li className="refund-list">Reason for the refund request.</li>
                                <li className="refund-list">Any supporting documentation (e.g., screenshots, receipts).</li>
                            </ul>
                            <p><strong>5. Changes to This Policy</strong></p>
                            <p><a href="https://padhaidekho.com">Padhaidekho.com</a> reserves the right to modify this refund policy at any time. Changes will be effective immediately upon posting on the website. Please review this policy periodically to stay informed about our terms.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* <button class="btn btn-primary enquire_now" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">Enquire Now</button> */}
      <Footer />
    </>
  )
}

export default RefundPage